var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contract-basic-info-container" }, [
    _c("div", { staticClass: "info-row" }, [
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("门店")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.form.dealerShopName || "-"))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("合同号")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.form.contractNo || "-"))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("合同类型")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.form.type || "-"))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("合同等级")]),
        _vm._v(" "),
        _c(
          "span",
          {
            class: [
              "contract-level-badge",
              {
                "main-contract": _vm.form.contractLevel === "主合同",
                "sub-contract": _vm.form.contractLevel === "子合同",
              },
            ],
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.form.contractLevel || "-") + "\n      "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "info-row" }, [
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("客户姓名")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.form.customerName || "-"))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("客户电话")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.form.customerPhone || "-"))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("订单类型")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.form.orderType || "-"))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("订单管理号")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.form.orderManagementNumber || "-"))]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "info-row" }, [
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("合同金额")]),
        _vm._v(" "),
        _c("span", { staticClass: "amount-text" }, [
          _vm._v("¥" + _vm._s((_vm.form.amount || 0).toFixed(2))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("预算金额")]),
        _vm._v(" "),
        _c("span", { staticClass: "amount-text" }, [
          _vm._v("¥" + _vm._s((_vm.form.budgetAmount || 0).toFixed(2))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("客户地址")]),
        _vm._v(" "),
        _c("span", { staticClass: "address-text" }, [
          _vm._v(_vm._s(_vm.form.address || "-")),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("label", [_vm._v("测未定")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.form.unmeasured || "-"))]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "media-section" }, [
      _c("div", { staticClass: "media-column" }, [
        _c("h4", [_vm._v("合同图片")]),
        _vm._v(" "),
        _c("div", { staticClass: "image-preview" }, [
          _vm.imageUrls.length > 0
            ? _c(
                "div",
                { staticClass: "image-list" },
                _vm._l(_vm.imageUrls, function (url, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "image-item",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("preview-image", url)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "preview-img",
                        attrs: { src: url, alt: "图片" + (index + 1) },
                      }),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "no-data" }, [_vm._v("无图片")]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "media-column" }, [
        _c("h4", [_vm._v("附件")]),
        _vm._v(" "),
        _c("div", { staticClass: "file-preview" }, [
          _vm.fileUrls.length > 0
            ? _c(
                "div",
                { staticClass: "file-list" },
                _vm._l(_vm.fileUrls, function (file, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "file-item",
                      on: {
                        click: function ($event) {
                          return _vm.openFile(file.url)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-document" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "file-name" }, [
                        _vm._v(_vm._s(file.name)),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "no-data" }, [_vm._v("无附件")]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }